import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { RootState } from "redux/store";
import { connect } from "react-redux";
import { styles } from "./style";
import { getRoundRobinRoutes, getUser } from "redux/selector";
import { AgentTag } from "component/shared/agent-tag";
import { AppCard } from "component/shared/app-card";

interface Props
	extends WithStyles<typeof styles>,
		ReturnType<typeof mapStateToProps> {}

const mapStateToProps = (state: RootState) => {
	const user = getUser(state);
	const roundRobinRoutes = getRoundRobinRoutes(state);
	return {
		roundRobinRoutes,
		user
	};
};

class Component extends React.Component<Props> {
	public render() {
		const { roundRobinRoutes, user } = this.props;
		const position = user.roundRobinPosition;
		const nextAssigned = roundRobinRoutes[position ? position - 1 : position];

		let agent;
		if (nextAssigned) {
			agent = nextAssigned.agent;
		}
		const enabled = user.roundRobinRouting;

		if (!enabled || !agent) {
			return null;
		}
		return (
			<Mui.Grid container direction="column" spacing={2}>
				<Mui.Grid item>
					<Mui.Typography variant="h3" color="textPrimary">Round Robin</Mui.Typography>
				</Mui.Grid>
				<Mui.Grid item>
					<AppCard><Mui.CardContent>
							<AgentTag 
								prefix="Next round robin lead assigned to"
								agent={agent}
								justifyContent="center"
							/>
					</Mui.CardContent></AppCard>
				</Mui.Grid>
			</Mui.Grid>
	);
}
}

export const RoundRobin = withStyles(connect(mapStateToProps)(Component), styles);
